import React from 'react';
import { Button, CheckBox, Hairline, View, Text } from '../elements';
import Theme, { hairline } from '../Theme';
import { T } from '../helpers/i18n';
import cxs from 'cxs/component';
import theme from '../Theme';
import { Label } from 'reactstrap';
import { toMoney } from '../helpers/Format';
import { UIMessage } from './index';
const styleCommon = {
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
};
export const BarCheckout = (props) => {
    const { loading, tempSaleTicket, boardingPass, valitedNow, printPrice, handleCheckbox, handleCheckOut, disableCheckout, disableValitedNow, disableboardingPass, } = props;
    return (React.createElement(View, { center: true, style: Object.assign(Object.assign({}, hairline.top), hairline.bottom) },
        React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
                borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
                height: 50,
            } },
            !disableValitedNow && (React.createElement(CheckBox, { onChange: (value) => handleCheckbox('valitedNow', value), label: T('valitedNow'), checked: valitedNow, style: { fontSize: '10px' } })),
            React.createElement(CheckBox, { onChange: (value) => handleCheckbox('printPrice', value), label: T('printPrice'), checked: printPrice, style: { fontSize: '10px' } }),
            !disableboardingPass && (React.createElement(CheckBox, { onChange: (value) => handleCheckbox('boardingPass', value), label: T('boardingPass'), checked: boardingPass, style: { fontSize: '10px' } }))),
        React.createElement(View, { flex: true, row: true, style: { width: '100%' } },
            React.createElement(View, { flex: 2 },
                React.createElement(Text, null, '')),
            React.createElement(WrapperButton, { loading: typeof loading === 'boolean' && loading, style: {
                    borderRadius: 5,
                }, onClick: () => handleCheckOut(false), disabled: disableCheckout, children: 'Emitir' }),
            React.createElement(View, { flex: 2 },
                React.createElement(UIMessage, { noTop: true })),
            (tempSaleTicket === null || tempSaleTicket === void 0 ? void 0 : tempSaleTicket.total) > 0 && (tempSaleTicket === null || tempSaleTicket === void 0 ? void 0 : tempSaleTicket.totalDue) < 0 && (React.createElement(View, { flex: true, center: true },
                React.createElement(Label, null, `${T('total')}: ${toMoney(tempSaleTicket.total, tempSaleTicket.money)}`),
                React.createElement(Label, null, `${T('totalPaid')}: ${toMoney(tempSaleTicket.total + tempSaleTicket.totalDue, tempSaleTicket.money)}`),
                React.createElement(Label, null, `${T('totalDue')}: ${toMoney(tempSaleTicket.totalDue, tempSaleTicket.money)}`)))),
        React.createElement(Hairline, { horizontal: true })));
};
const WrapperButton = cxs(Button)(({ disabled }) => ({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: `${disabled ? theme.color.primary : 'black'}`,
    padding: '8px',
    margin: '5px 10px',
    color: disabled ? 'gray' : undefined,
    ':hover': {
        borderColor: disabled ? undefined : theme.color.primary,
        color: disabled ? undefined : theme.color.primary,
        borderWidth: disabled ? undefined : '2px',
        padding: disabled ? undefined : '7px',
        cursor: disabled ? undefined : 'pointer',
    },
}));



//////////////////
// WEBPACK FOOTER
// ./src/components/BarCheckout.tsx
// module id = 159
// module chunks = 0